// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill"
import 'jquery'

Vue.config.productionTip = false

// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Axios from 'axios'
Vue.prototype.$axios = Axios
Axios.defaults.baseURL = 'http://minyingapi.zhengshang100.com';
Axios.defaults.timeout = 10000;


// 引入echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts


// // 封装的axios方法
import request from "./api/request";
Vue.prototype.$get = request.getRequest;
Vue.prototype.$post = request.postRequest;
// // axios接口列表
import requestApi from "./api/index";
Vue.prototype.$api = requestApi;

// 引入highcharts
import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue);
//引入城市控件
// import GetCitryData from '../src/assets/js/GetCitryData.js';
// Vue.prototype.$GetCitry = GetCitryData

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js